import { Formik, Form } from 'formik';
import React, { memo, useCallback, useState, useEffect } from 'react';
import { useQuery } from 'v2/hooks/useQuery';
import affiliateService, { InitialFilter } from 'v2/services/affiliate';

import type { IFilter, IStatusFilter } from 'v2/interfaces/affiliate';

import Basic from './Basic';
import styles from './styles';
import FilterAffiliateSchema from './validations';

import type { FormikProps } from 'formik';

const Filter = () => {
  const classes = styles({});
  const [filter, setFilter] = useState<IFilter>(InitialFilter);
  const params = useQuery();

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    affiliateService.setFilter(values);
    setSubmitting(false);
  }, []);

  useEffect(() => {
    const product = params.get('p');
    const status = params.get('status');
    let f = filter;
    if (product) {
      f.product_id = [Number(product)];
    }
    if (status) {
      const s: IStatusFilter = status as IStatusFilter;
      f.status = s;
    }
    setFilter(f);
  }, [filter, params]);

  return (
    <div className={classes.filter}>
      <Formik initialValues={filter} validationSchema={FilterAffiliateSchema} onSubmit={onSubmit}>
        {() => (
          <Form>
            <Basic />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default memo(Filter);
